<template>
    <div v-if="courseItem?.options['has_certification']">
        <div class="certificat-box">
            <p class="text-24 fw-600">{{ $t("certificate.title") }}</p>
            <span class="text-16 fw-400">{{ $t("certificate.description") }}</span>
            <router-link to="/certificate"
                class="request-btn fw-600 text-16 d-flex justify-content-center align-items-center mt-35">
                {{ $t("certificate.button") }}
            </router-link>

        </div>
    </div>
</template>
<script>
export default {
    computed: {
        courseItem() {
            return this.$store.getters.courseItem;
        },
    },
}
</script>
<style scoped lang="scss">
.certificat-box {
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 32px;
    padding-top: 16px;
    border-radius: 8px;
    background: #F6F8F8;

    &:lang(en) {
        font-family: "Montserrat", sans-serif;
    }

    &:lang(ar) {
        font-family: "Almarai", serif;
    }

    p,
    span,
    button {
        line-height: 140%;
    }

    p {
        color: var(--Primary-600, #09445D);
        margin-bottom: 16px;
    }

    span {
        color: var(--Neutral-600, #666);
    }

    .request-btn {
        color: var(--Primary-700, #062B3B);
        padding: 14px 40px;
        gap: 8px;
        border-radius: 8px;
        border: 1px solid var(--Primary-700, #062B3B);
        cursor: pointer;
        -webkit-transition: 0.2s ease-in-out;
        -o-transition: 0.2s ease-in-out;
        transition: 0.2s ease-in-out;

        &:hover {
            background: #062B3B;
            color: #fff !important
        }
    }
}
</style>